<template>
  <!-- /** If has click and no to  */ -->
  <ims-button
    rippleColor="rgba(0,0,0,0.2)"
    v-if="hasClickEvent() && !to && !href"
    @click="$emit('click')"
    class="ims-list-item button-item"
  >
    <div
      v-if="slotExists('left')"
      class="item-start"
    >
      <slot name="left"></slot>
    </div>
    <div
      v-if="slotExists('content')"
      class="item-content"
    >
      <slot name="content"></slot>
    </div>
    <div
      v-if="!slotExists('content')"
      class="item-content"
    >
      <slot></slot>
    </div>
    <div
      v-if="slotExists('right') || detail"
      class="item-end"
    >
      <slot name="right"></slot>
      <ims-icon
        icon="chevron_right"
        v-if="detail"
        color="faded"
      />
    </div>
  </ims-button>
  <!-- If a TO is provided.. Use a router link control -->
  <router-link
    v-else-if="to"
    :to="to"
    class="ims-list-item router-item"
    @click.native="nativeClick"
  >
    <ims-button
      rippleColor="rgba(0,0,0,0.2)"
      class="ims-list-item button-item"
    >
      <div
        v-if="slotExists('left')"
        class="item-start"
      >
        <slot name="left"></slot>
      </div>
      <div
        v-if="slotExists('content')"
        class="item-content"
      >
        <slot name="content"></slot>
      </div>
      <div
        v-if="!slotExists('content')"
        class="item-content"
      >
        <slot></slot>
      </div>
      <div
        v-if="slotExists('right') || detail"
        class="item-end"
      >
        <slot name="right"></slot>
        <ims-icon
          icon="chevron_right"
          v-if="detail"
          color="faded"
        />
      </div>
    </ims-button>
  </router-link>
  <!-- else - plain item  -->
  <div
    v-else
    class="ims-list-item plain-item"
    @click="genericClick"
  >
    <div
      v-if="slotExists('left')"
      class="item-start"
    >
      <slot name="left"></slot>
    </div>
    <div
      v-if="slotExists('content')"
      class="item-content"
    >
      <slot name="content"></slot>
    </div>
    <div
      v-if="!slotExists('content')"
      class="item-content"
    >
      <slot></slot>
    </div>
    <div
      v-if="slotExists('right') || detail"
      class="item-end"
    >
      <slot name="right"></slot>
      <ims-icon
        icon="chevron_right"
        v-if="detail"
        color="faded"
      />
    </div>
  </div>
</template>

<style lang="scss">
@import '../../scss/utils/variables';
@import '../../scss/vendors/bootstrap-utils';

.ims-list-item {
  @include disable-selection();
  $leftBuffer: 16px;
  $rightBuffer: 16px;
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: stretch;
  justify-content: stretch;
  min-height: 40px;
  background: #fff;
  appearance: none;
  border: none;
  text-decoration: none !important;
  position: relative;
  cursor: pointer;

  &:after {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 16px;
    border-top: solid 1px rgba(0, 0, 0, 0.1);
    content: '';
  }

  &.double {
    .item-content {
      min-height: 60px;
    }
  }

  &.pad {
    .item-content {
      padding-top: 10px;
      padding-bottom: 10px;
    }
  }

  &[disabled] {
    opacity: 0.6;
  }

  &.ims-button {
    padding: 0;
  }
  .item-end {
    flex-shrink: 0;
    padding: 6px $rightBuffer 6px 0;
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .item-start {
    flex-shrink: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 6px 0 6px $leftBuffer;
  }

  &.compact {
    font-size: $font-sm;
    .title,
    h1,
    h2 {
      font-size: $font-sm;
    }
  }

  .title,
  h1,
  h2 {
    font-size: $font-md;
    margin: 0;
    padding: 0;
    font-weight: 600;
    line-height: 115%;
  }
  .note,
  p {
    font-size: $font-sm * 0.85;
    line-height: $font-sm * 0.9;
    opacity: 0.9;
    margin: 0 !important;
    margin-top: 4px !important;
    padding: 0;
  }

  &.divider {
    background-color: $color-bg;
    min-height: 30px !important;
    color: $gray-600;
    padding-top: 10px;
    .item-content {
      font-weight: 700;
    }

    &:after {
      left: 0;
    }
  }

  &.ims-item-last {
    &:after {
      left: 0;
    }
  }

  &.no-border {
    .item-content,
    .item-end {
      border-bottom: none !important;
    }

    &:after {
      display: none;
    }
  }

  .item-content {
    flex-grow: 1;
    flex-shrink: 1;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    align-content: center;
    justify-content: center;
    // border-bottom: solid 1px rgba(180, 180, 180, 0.12);
    min-height: 40px;
    text-align: left;
    padding-left: $leftBuffer;
    padding-right: $rightBuffer;
  }
  .item-end {
    // border-bottom: solid 1px rgba(180, 180, 180, 0.12);
  }
}
</style>

<script>
/**
 * List Item
 * Generic item for creating rich mobile friendly lists.
 * It's broken down into 3 top level tags.
 * - router-link - for items that need to use the router
 * - @click - items with an @click will turn into a ims-button
 * - plain - anything else is a generic non -clickable item
 */
export default {
  props: {
    to: {
      type: String,
      default() {
        return null;
      }
    },
    click: {
      type: Function,
      default() {
        return null;
      }
    },
    href: {
      type: String,
      default() {
        return null;
      }
    },
    target: {
      type: String,
      default() {
        return null;
      }
    },
    detail: {
      default() {
        return false;
      }
    }
  },
  methods: {
    nativeClick() {
      this.$emit('click');
    },
    genericClick() {
      if (this.href) {
        if (this.target) {
          window.open(this.href, this.target);
        } else {
          window.location.href = this.href;
        }
      }
    },
    hasClickEvent() {
      return this.$listeners && this.$listeners.click;
    },
    slotExists(name) {
      if (name) {
        return this.$slots.hasOwnProperty(name);
      } else {
        return this.$slots.hasOwnProperty('default');
      }
    }
  },
  computed: {}
};
</script>
